import { render } from "./users-page.vue?vue&type=template&id=59cb4ef1&scoped=true"
import script from "./users-page.vue?vue&type=script&lang=js"
export * from "./users-page.vue?vue&type=script&lang=js"

import "./users-page.vue?vue&type=style&index=0&id=59cb4ef1&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59cb4ef1"]])

export default __exports__